import { render, staticRenderFns } from "./logisticsBill.vue?vue&type=template&id=75e7f551&scoped=true"
import script from "./logisticsBill.vue?vue&type=script&lang=js"
export * from "./logisticsBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e7f551",
  null
  
)

export default component.exports